import { render } from "./TECMQuestionsSimuladoLanding.vue?vue&type=template&id=5b2906b0&scoped=true"
import script from "./TECMQuestionsSimuladoLanding.vue?vue&type=script&lang=js"
export * from "./TECMQuestionsSimuladoLanding.vue?vue&type=script&lang=js"

import "./TECMQuestionsSimuladoLanding.vue?vue&type=style&index=0&id=5b2906b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2906b0"]])

export default __exports__